import _toArray from "@babel/runtime/helpers/toArray";
export var getPositionInMasked = function getPositionInMasked(value, mask, position) {
  var result = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  if (mask.length === 0) {
    return result;
  }

  var _mask = _toArray(mask),
      maskHead = _mask[0],
      maskTail = _mask.slice(1);

  if (position === 0) {
    if (maskHead === null || maskHead === value[0]) {
      return result;
    }

    return getPositionInMasked(value, maskTail, position, result + 1);
  }

  if (maskHead === null || maskHead === value[0]) {
    return getPositionInMasked(value.slice(1), maskTail, position - 1, result + 1);
  }

  return getPositionInMasked(value, maskTail, position, result + 1);
};
export var getPositionInValue = function getPositionInValue(value, mask, position) {
  var result = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : position;

  if (mask.length === 0 || position === 0) {
    return result;
  }

  var _mask2 = _toArray(mask),
      maskHead = _mask2[0],
      maskTail = _mask2.slice(1);

  if (maskHead === null || maskHead === value[0]) {
    return getPositionInValue(value.slice(1), maskTail, position - 1, result);
  }

  return getPositionInValue(value, maskTail, position - 1, result - 1);
};
export var applyMask = function applyMask(value, mask) {
  var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (value.length === 0 || mask.length === 0) {
    return result;
  }

  var _mask3 = _toArray(mask),
      maskHead = _mask3[0],
      maskTail = _mask3.slice(1);

  if (maskHead === null || maskHead === value[0]) {
    return applyMask(value.slice(1), maskTail, result + value[0]);
  }

  return applyMask(value, maskTail, result + maskHead);
};
export var isLongerThanMask = function isLongerThanMask(value, mask) {
  if (mask.length === 0) {
    if (value.length > 0) {
      return true;
    }

    return false;
  }

  if (value.length === 0) {
    return false;
  }

  var _mask4 = _toArray(mask),
      maskHead = _mask4[0],
      maskTail = _mask4.slice(1);

  if (maskHead === null || maskHead === value[0]) {
    return isLongerThanMask(value.slice(1), maskTail);
  }

  return isLongerThanMask(value, maskTail);
};
//# sourceMappingURL=index.js.map